import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Icon3D } from "@/components/ui/icon-3d";

interface HelpDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function HelpDialog({ open, onOpenChange }: HelpDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Help & Support</DialogTitle>
          <DialogDescription>
            Get help with Aegis and learn how to protect your digital continuity
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-4">
          {/* Documentation */}
          <div className="space-y-3">
            <h4 className="text-sm font-semibold">Documentation</h4>
            <div className="space-y-2">
              <Button variant="outline" className="w-full justify-start gap-3" asChild>
                <a href="/docs/getting-started" target="_blank" rel="noopener noreferrer">
                  <Icon3D name="documents" size="sm" />
                  Getting Started Guide
                  <Icon3D name="external-link" size="xs" className="ml-auto" />
                </a>
              </Button>
              <Button variant="outline" className="w-full justify-start gap-3" asChild>
                <a href="/docs/best-practices" target="_blank" rel="noopener noreferrer">
                  <Icon3D name="documents" size="sm" />
                  Best Practices
                  <Icon3D name="external-link" size="xs" className="ml-auto" />
                </a>
              </Button>
              <Button variant="outline" className="w-full justify-start gap-3" asChild>
                <a href="/docs/security" target="_blank" rel="noopener noreferrer">
                  <Icon3D name="documents" size="sm" />
                  Security & Privacy
                  <Icon3D name="external-link" size="xs" className="ml-auto" />
                </a>
              </Button>
            </div>
          </div>

          {/* Support */}
          <div className="space-y-3">
            <h4 className="text-sm font-semibold">Contact Support</h4>
            <div className="space-y-2">
              <Button variant="outline" className="w-full justify-start gap-3" asChild>
                <a href="mailto:support@aegis.example.com">
                  <Icon3D name="email" size="sm" />
                  Email Support
                  <Icon3D name="external-link" size="xs" className="ml-auto" />
                </a>
              </Button>
              <Button variant="outline" className="w-full justify-start gap-3" asChild>
                <a href="/support/chat" target="_blank" rel="noopener noreferrer">
                  <Icon3D name="sms" size="sm" />
                  Live Chat
                  <Icon3D name="external-link" size="xs" className="ml-auto" />
                </a>
              </Button>
            </div>
          </div>

          {/* Quick Tips */}
          <div className="rounded-lg bg-muted p-4 space-y-2">
            <h4 className="text-sm font-semibold">Quick Tips</h4>
            <ul className="text-sm text-muted-foreground space-y-1.5 list-disc list-inside">
              <li>Start by adding your most critical assets and contacts</li>
              <li>Set up at least one verification trigger</li>
              <li>Review your continuity plan regularly</li>
              <li>Nothing activates instantly - everything requires verification</li>
            </ul>
          </div>

          {/* Version Info */}
          <div className="pt-4 border-t border-border">
            <p className="text-xs text-muted-foreground text-center">
              Aegis v1.0.0 • <a href="/changelog" className="hover:text-foreground">Changelog</a>
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
